import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";

export type CurrentChatInputMessages = ActionButtonMessages & {
  currentChatInputPlaceholder: string;
  talk2buy: string;
  mediaImageOrVideo: string;
  mediaDocument: string;
  activateBot: string;
  noPreviewAvailable: string;
  loadMoreMessages: string;

  // Messages for DisplayMedia
  loading: string;
  videoNotSupported: string;
  audioNotSupported: string;
  documentLabel: string;
  download: string;
  openLink: string;
  unsupportedMediaType: string;
  expandImage: string;
  closeImagePreview: string;
  zoomIn: string;
  zoomOut: string;
  resetZoom: string;

  // Message delivery status (WhatsApp ticks)
  deliveryStatusPending: string;
  deliveryStatusSent: string;
  deliveryStatusDelivered: string;
  deliveryStatusRead: string;
  deliveryStatusFailed: string;

  // CurrentChatOptionsPopover
  assumeControl: string;
  finishControl: string;
  transferStepMenu: string;
};

export const CURRENT_CHAT_INPUT_MESSAGES: CurrentChatInputMessages = {
  currentChatInputPlaceholder: "Escreva uma mensagem",
  talk2buy: "Talk2Buy",
  mediaImageOrVideo: "Imagem ou Vídeo",
  mediaDocument: "Documento",
  activateBot: "Ativar agente",
  noPreviewAvailable: "Pré-visualização não disponível",
  loadMoreMessages: "Carregar mais mensagens",

  // Messages for DisplayMedia
  loading: "Carregando...",
  videoNotSupported: "Seu navegador não suporta o formato de vídeo.",
  audioNotSupported: "Seu navegador não suporta o formato de áudio.",
  documentLabel: "Documento:",
  download: "Download",
  openLink: "Abrir link",
  unsupportedMediaType: "Tipo de mídia não suportado",
  expandImage: "Ampliar imagem",
  closeImagePreview: "Fechar",
  zoomIn: "Aumentar zoom",
  zoomOut: "Diminuir zoom",
  resetZoom: "Ajustar à tela",

  // Message delivery status (WhatsApp ticks)
  deliveryStatusPending: "Enviando",
  deliveryStatusSent: "Enviada",
  deliveryStatusDelivered: "Entregue",
  deliveryStatusRead: "Lida",
  deliveryStatusFailed: "Falha no envio",

  //ACTION_BUTTONS
  ...ACTION_BUTTON_MESSAGES,

  // CurrentChatOptionsPopover
  assumeControl: "Assumir Atendimento",
  finishControl: "Finalizar Atendimento",
  transferStepMenu: "Transferência de etapa",
};
